import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {FeatureTypeService} from '@catcore/services';
import {Feature} from '@catcore/services/feature/feature';
import {GenericLinkedResource} from '@catcore/types/base';
import {navigateToFeatureResource} from '@catfeatures/shared/utils';
import {FeatureUnitsService} from '@catmodules/models/feature-units/services/feature-units.service';
import {FeatureUnit} from '@catmodules/models/feature-units/types';
import {EntityForm} from '@catmodules/ui-models/shared/entity-form';
import {LinkItem} from '@catui/types';
import {Subscription} from "rxjs/Subscription";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {extractDataFromModel} from "@catcore/utils";
import {ConfirmationService} from "primeng/primeng";
import {UpdateService} from "@catcore/services/update.service";

const componentBaseName = 'feature-unit-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-feature-unit-form',
  templateUrl: './feature-unit-form.component.html',
})
export class FeatureUnitFormComponent extends EntityForm implements OnInit, OnDestroy {
  labels = {
    updateGroup: 'Update group',
    locationAddress: 'Location address',
    position: 'Position',
    name: 'Name',
    partNumber: 'Part number',
    description: 'Description',
    display_label: 'Display label',
  };
  @HostBinding('class') classNames = defaultClassNames;

  linkedParameterItems: LinkItem[] = [];

  private feature: Feature;
  featureUnit: FeatureUnit;

  featureSubscription: Subscription;

  private currentResourceService;

  constructor(formBuilder: FormBuilder,
              private featureUnitService: FeatureUnitsService,
              private router: Router,
              private featureService: FeatureTypeService,
              private genericService: GenericResourceService,
              private updateService: UpdateService) {
    super(formBuilder);
  }

  ngOnInit() {
    this.featureSubscription = this.featureService
      .getCurrent()
      .subscribe((feature: Feature) => this.feature = feature);
  }

  onEntityReceived(entity) {
    this.currentResourceService = this.genericService.findServiceForResource(this.resourceUri);
  }

  ngOnDestroy() {
    this.featureSubscription.unsubscribe();
  }

  refreshResource() {
    this.currentResourceService.refresh();
  }

  afterDelete() {
    this.featureService.refreshCurrent();
    this.router.navigate(['features', this.feature.id, 'units']);
  }

  afterUpdateForm() {
    const items: LinkItem[] = [];
    const model: FeatureUnit = this.getModel();
    this.featureUnit = this.getModel();

    this.featureUnitService
      .extractParametersFor(model)
      .forEach((item: GenericLinkedResource) => {
        items.push({label: item.label, navigate: initGoToFeatureUnitParameter(item, this.feature)});
      });
    this.linkedParameterItems = items;
  }

  onUpdate() {
    this.updateService.update(
      () => this.featureUnitService.updateFromModel(this.featureUnit.id),
      () => this.refreshResource(),
      'feature unit');
  }

  protected afterFormSubmit(result: any) {
      this.featureService.refreshCurrent();
  }
}

const initGoToFeatureUnitParameter = (item: GenericLinkedResource, feature: Feature) => {
  return (router: Router) => navigateToFeatureResource(router, feature, item);
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-units/components/feature-unit-form/feature-unit-form.component.ts